import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ButtonT1 } from "../../../../components/atoms/Button/Button";
import { authUser } from "../../../../store/slice/authSlice";
import { BannerCloseButton, useBannerDismiss } from "./DismissibleBanner";

const BannerBar = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 10px 48px;
  background: #fff8e6;
  border-bottom: 1px solid #f0e0b2;
  color: #262641;
  font-size: 14px;
  line-height: 150%;
  text-align: center;
`;

const STATUS_COPY = {
  needs_plan: {
    message: "Choose a plan to start your free trial",
    showButton: true,
  },
  read_only: {
    message: "Your account is read-only. Choose a plan to continue.",
    showButton: true,
  },
  pending_review: {
    message: "Your account is being reviewed.",
    showButton: false,
  },
};

/**
 * Shown for Shopify-billed companies that still need a plan or are gated.
 */
export const ShopifyBillingBanner = () => {
  const navigate = useNavigate();
  const user = useSelector(authUser);
  const [dismissed, dismiss] = useBannerDismiss(
    `shopifyBillingBannerDismissed:${user?.account_status ?? ""}`
  );

  if (!user || user.billing_method !== "shopify" || dismissed) return null;

  const copy = STATUS_COPY[user.account_status];
  if (!copy) return null;

  return (
    <BannerBar role="status">
      <span>{copy.message}</span>
      {copy.showButton ? (
        <ButtonT1
          title="Choose a plan"
          onClickCallback={() => {
            if (user.shopify_pricing_url) {
              window.location.href = user.shopify_pricing_url;
              return;
            }
            navigate("/integration/shopify");
          }}
        />
      ) : null}
      <BannerCloseButton onClick={dismiss} />
    </BannerBar>
  );
};
